import React from 'react';
import GameQuery from '../../query/GameQuery';
import InboxMessage from '../../components/InboxMessage';

const InboxMessageRoute = ({ match }) => (
	<GameQuery>
		{({ game }) => {
			const message = game.emails.find(
				message => message.id === match.params.messageID
			);
			return <InboxMessage message={message} />;
		}}
	</GameQuery>
);

export default InboxMessageRoute;
